import { body } from 'msw/lib/types/context';

import { IdentifierDTO } from '@zazume/zzm-base';

import { BillingData } from '#/models/BillingData';

import { PaymentsLedgerAccount } from '../../../../models/accounting/PaymentsLedgerAccount';
import { doGet, doPatch, doPost } from '../../helpers';

export const accounting = {
  paymentsLedgerAccount: {
    getPaymentsLedgerAccount: (organizationId: IdentifierDTO) => () =>
      doGet<PaymentsLedgerAccount | undefined>(`/dashboard/accounting/payments/ledger-account/${organizationId}`),
    updatePaymentsLedgerAccount: (organizationId: IdentifierDTO) => (body: PaymentsLedgerAccount) =>
      doPatch(`/dashboard/accounting/payments/ledger-account/${organizationId}`, body),
    verifyBillingData: (organizationId: IdentifierDTO) => (body: BillingData) =>
      doPost<{ isValid: boolean }>(`/dashboard/accounting/verify/billing-data/${organizationId}`, body)
  }
};
